<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" label-position="left" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('图片')" prop="photo">
        <pic-upload
            width="80px"
            height="80px"
            :download-url="$api.file.downloadImg"
            :action="$api.file.upload"
            v-model="formData.photo"
            :limit="1" />
        <span style="color: red">{{$t('建议大小')}} 702 * 390</span>
      </el-form-item>

      <el-form-item :label="$t('优先级')" prop="priority">
        <el-input :placeholder="$t('优先级别')" v-model.number="formData.priority" />
      </el-form-item>

      <el-form-item :label="$t('广告链接网址')" prop="link">
        <el-input :placeholder="$t('广告链接网址')" v-model="formData.link"  />
      </el-form-item>

      <el-form-item :label="$t('滑动设置')" prop="slideSet">
        <div class="flex">
          <el-input :placeholder="$t('滑动设置')" v-model.number="formData.slideSet" />
          <span style="flex-shrink: 0; margin-left: 10px">{{$t('单位')}}：{{$t('秒')}}</span>
        </div>
      </el-form-item>

      <el-form-item :label="$t('状态')">
        <dict-select flag="BANNER_STATUS" v-model="formData.status" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button @click="resetForm">{{$t('重置')}}</el-button>
    </template>

  </el-dialog>
</template>

<script>
import PicUpload from "@/components/pic-upload/PicUpload";
import {resetEmpty} from "@/utils/common";
import DictSelect from "@/components/dict/DictSelect";

// 默认字段
const defaultFormData = {
  status: "open",
  slideSet: 3,
}

export default {
  name: "AdvAddOrEdit",
  components: {DictSelect, PicUpload},
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        photo: "",
        priority: null,
        link: "",
        ...defaultFormData
      },

      rules: {
        photo: {required: true, message: this.$t('请上传图片'), trigger: "change"},
        priority: [
          {required: true, message: this.$t('请输入优先级'), trigger: "blur"},
          {type: "number", message: this.$t('优先级必须为数字值'), trigger: "blur"}
        ],
        slideSet: [
          {required: true, message: this.$t('请输入滑动设置'), trigger: "blur"},
          {type: "number", message: this.$t('滑动设置必须为数字值'), trigger: "blur"}
        ],
        link: [
          {required: true, message: this.$t('请输入链接地址'), trigger: "blur"},
          {pattern: /^https?:\/\//, message: this.$t('请输入正确的链接地址'), trigger: "blur"}
        ],
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if(!valid) return;
        this.$emit("save", {...this.formData});
      })
    },

    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData = {...this.formData, ...defaultFormData};
    }
  },
  watch: {
    // 监听上传图片
    "formData.photo": {
      handler(val) {
        if(val) {
          this.$nextTick(() => {
            this.$refs.form.clearValidate("photo");
          })
        }
      }
    },
    data: {
      handler(val) {
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
        this.formData = Object.assign(defaultFormData, this.formData);
        this.formData.slideSet = parseInt(this.formData.slideSet);
        this.formData.priority  =  parseInt(this.formData.priority);
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
